import 'bootstrap/dist/js/bootstrap.bundle'
import { NavLink } from 'react-router-dom';
import { useGetSettingQuery } from '../../../Redux/Apis/siteApi';
import { Map } from '../../Theme_4/Components/Map';
import { useEffect } from 'react';
import $ from 'jquery';
import { HashLink } from 'react-router-hash-link';
import { Link } from 'react-router-dom';

function toTop() {
    const body = document.querySelector('#ScrollTop');
    body?.scrollIntoView({
        block: 'start',
        inline: 'start',
        behavior: 'smooth'
    })
}
export default function Footer(){
    const {data : { name,description, menu, contacts }} = useGetSettingQuery()
    useEffect(() => {
        window.addEventListener('scroll', stickNavbar);
        return () => {
            window.removeEventListener('scroll', stickNavbar);
        };
    }, [])
    
    const stickNavbar = () => {
        if (window !== undefined) {
            let windowHeight = window.scrollY;
            if(windowHeight > 45) {$('.back-to-top').removeClass('d-none'); $('.back-to-top').addClass('d-block')}
            else {$('.back-to-top').removeClass('d-block'); $('.back-to-top').addClass('d-none');}
        }
    };

    return (
        <>
        <div className="container-fluid bg-dark text-light footer mt-5 pt-5 wow fadeIn" data-wow-delay="0.1s">
            <div className="container py-5">
                <div className="row g-5">
                    <div className="col-lg-4 col-md-6">
                        <Link to="/" className="navbar-brand d-flex align-items-center mb-3">
                            <h3 className="m-0 text-primary">{name}</h3>
                        </Link>
                        <p>{description}</p>
                    </div>
                    <div className="col-lg-2 col-md-6">
                        <h4 className="text-light mb-4">سایر بخش ها</h4>
                        {menu && menu.map((row,index) => 
                            row.value !== "/" && 
                                <div key={index}> {row.value.includes("#") ? 
                                    <HashLink className="btn btn-link" to={`/${row.value}`} data-animate="scrolling">{row.key}</HashLink>
                                    :
                                    <NavLink className="btn btn-link" to={row.value} end caseSensitive>{row.key}</NavLink>}
                                </div>
                        )}
                    </div>
                    <div className="col-lg-3 col-md-6">
                        <h4 className="text-light mb-4">ارتباط با ما</h4>
                        {contacts.address && <p className="mb-2"><i className="fa fa-map-marker-alt me-2"></i>{contacts.address}</p>}
                        {contacts.mobile && <p className="mb-2"><a className='text-light' href={`tel:${contacts.mobile}`}><i className="fa fa-mobile me-2"></i>{contacts.mobile}</a></p>}
                        {contacts.phone && <p className="mb-2"><a className='text-light' href={`tel:${contacts.phone}`}><i className="fas fa-phone me-2"></i>{contacts.phone}</a></p>}
                        {contacts.email && <p className="mb-2"><a className='text-light' href={`mailto:${contacts.email}`}><i className="fa fa-envelope me-2"></i>{contacts.email}</a></p>}
                        <div className="d-flex pt-2">
                            {contacts.socials && contacts.socials.map((row,index) =>
                                {
                                    if(row.value !== ''){
                                        switch (row.key) {
                                            case 'فیسبوک':
                                                return <a key={index} className="btn btn-outline-light btn-social" href={row.value}><i className="fab fa-facebook-f"></i></a>
                                            case 'توییتر':
                                                return <a key={index} className="btn btn-outline-light btn-social" href={row.value}><i className="fab fa-twitter"></i></a>
                                            case 'اینستاگرام':
                                                return <a key={index} className="btn btn-outline-light btn-social" href={row.value}><i className="fab fa-instagram"></i></a>
                                            case 'یوتیوب':
                                                return <a key={index} className="btn btn-outline-light btn-social" href={row.value}><i className="fab fa-youtube"></i></a>
                                        
                                            default:
                                                return <div key={index}></div>
                                        }
                                    } else {
                                        return <div key={index}></div>
                                    }
                                }
                            )}
                        </div>
                    </div>
                    <div className="col-lg-3 col-md-6">
                        <h4 className="text-light mb-4">مراجعه حضوری</h4>
                        {contacts.location && <Map lat={contacts.location.lat} lng={contacts.location.lng} name={name}/>}
                    </div>
                </div>
            </div>
            <div className="container">
                <div className="copyright">
                    <div className="row">
                        <div className="col-md-6 text-center text-md-start mb-3 mb-md-0">
                            &copy; تمامی حقوق برای <a className="border-bottom" href="/">{name}</a>، محفوظ است.
                        </div>
                        <div className="col-md-6 text-center text-md-end">
                            ساخته شده با <span className="fa fa-heart text-danger"></span> در <a className="border-bottom" href="https://www.linket.me/">لینکت</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <button className="btn btn-lg btn-primary btn-lg-square rounded-0 back-to-top d-none" onClick={toTop}>
            <i className="fas fa-arrow-up"></i>
        </button>
        </>
    )
}